import { render } from "./CompanyEdit.vue?vue&type=template&id=33598288"
import script from "./CompanyEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Company/CompanyEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33598288"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33598288', __exports__)) {
    api.reload('33598288', __exports__)
  }
  
  module.hot.accept("./CompanyEdit.vue?vue&type=template&id=33598288", () => {
    api.rerender('33598288', render)
  })

}


export default __exports__